<template>
  <div class="slide">
    <div class="shap-one" style="pointer-events: none;"></div>
    <div class="shap-two" style="pointer-events: none;"></div>
    <div class="row">
      <div class="col-md-6">
        <div class="img-cont">

        </div>
      </div>
      <div class="col-md-6">
        <div class="disc">
          <h3>Gv stores</h3>
          <p>What are you looking for today?!..</p>
          <a href="https://gvmusic.ae/" target="_blank" class="gvmusic">GVMUSIC
            <svg width="20" height="10" viewBox="0 0 20 10" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                  d="M19.7709 4.44699C19.7706 4.44676 19.7704 4.44648 19.7702 4.44625L15.688 0.383747C15.3821 0.0794115 14.8875 0.0805441 14.5831 0.386403C14.2787 0.692224 14.2799 1.18687 14.5857 1.49125L17.3265 4.21875H0.78125C0.349766 4.21875 0 4.56851 0 5C0 5.43148 0.349766 5.78125 0.78125 5.78125H17.3264L14.5857 8.50875C14.2799 8.81312 14.2788 9.30777 14.5831 9.61359C14.8875 9.91949 15.3822 9.92054 15.688 9.61625L19.7702 5.55375C19.7704 5.55351 19.7706 5.55324 19.7709 5.55301C20.0769 5.24761 20.0759 4.75136 19.7709 4.44699Z"
                  fill="white"/>
            </svg>
          </a>

          <a href="https://gvtronics.ae/" target="_blank" class="gvtronics">GVTRONICS
            <svg width="20" height="10" viewBox="0 0 20 10" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                  d="M19.7709 4.44699C19.7706 4.44676 19.7704 4.44648 19.7702 4.44625L15.688 0.383747C15.3821 0.0794115 14.8875 0.0805441 14.5831 0.386403C14.2787 0.692224 14.2799 1.18687 14.5857 1.49125L17.3265 4.21875H0.78125C0.349766 4.21875 0 4.56851 0 5C0 5.43148 0.349766 5.78125 0.78125 5.78125H17.3264L14.5857 8.50875C14.2799 8.81312 14.2788 9.30777 14.5831 9.61359C14.8875 9.91949 15.3822 9.92054 15.688 9.61625L19.7702 5.55375C19.7704 5.55351 19.7706 5.55324 19.7709 5.55301C20.0769 5.24761 20.0759 4.75136 19.7709 4.44699Z"
                  fill="#DA0A2C"/>
            </svg>
          </a>
        </div>

      </div>
    </div>
  </div>
</template>

<style lang="scss">
@import "~@/assets/store/styles.scss";

.slide {
  background: #F1F1F1;
  width: 100%;
  height: 900px;
  position: relative;
  overflow: hidden;
  @media (min-width: $width1) and (max-width: $width2) {
    height: 516px;
  }

  .shap-one {
    position: absolute;
    width: 150%;
    height: 100%;
    left: -1600px;
    top: -350px;
    background: radial-gradient(38.86% 38.86% at 50% 50%, #DA0A2C 0%, rgba(255, 255, 255, 0) 100%);
    z-index: 9;
    @media (min-width: $width1) and (max-width: $width2) {
      width: 117%;
      height: 100%;
      right: -203px;
      top: -329px;
      left: unset;
    }
  }

  .shap-two {
    position: absolute;
    width: 100%;
    height: 130%;
    right: -1150px;
    top: -50px;
    background: radial-gradient(38.86% 38.86% at 50% 50%, #DA0A2C 0%, rgba(255, 255, 255, 0) 100%);
    z-index: 9;
    @media (min-width: $width1) and (max-width: $width2) {
      width: 100%;
      height: 105%;
      left: -212px;
      bottom: -96px;
      right: unset;
      top: unset;
    }
  }

  .img-cont {
    height: 906px;
    width: 135%;
    position: relative;
    background: linear-gradient(270deg, #F1F1F1 3.42%, rgba(241, 241, 241, 0) 66.14%), url('~@/assets/store/img/slide-bg.png'), #F1F1F1;
    background-repeat: no-repeat;
    @media (min-width: $width1) and (max-width: $width2) {
      height: 516px;
      width: 100%;
      position: relative;
      background: linear-gradient(270deg, #F1F1F1 3.42%, rgba(241, 241, 241, 0) 66.14%), url('~@/assets/store/img/smbg.png'), #F1F1F1;
      background-size: cover;
    }
  }

  .disc {
    position: relative;
    top: 37%;
    left: 200px;
    @media (min-width: $width1) and (max-width: $width2) {
      top: -130%;
      left: 25px;
    }

    h3 {
      font-family: Roboto;
      font-style: normal;
      font-weight: 500;
      font-size: 60px;
      line-height: 69px;
      text-align: justify;
      color: #161616;
      @media (min-width: $width1) and (max-width: $width2) {
        font-size: 40px;
        line-height: 34px;
      }
    }

    p {
      font-family: Roboto;
      font-style: normal;
      font-weight: 300;
      font-size: 20px;
      line-height: 131%;
      color: #161616;
      margin-bottom: 60px;
      @media (min-width: $width1) and (max-width: $width2) {
        font-size: 15px;
        line-height: 131%;
        margin-bottom: 20px;
      }

    }

    .gvmusic {
      background: linear-gradient(90deg, #DA0A2C 0%, #DA0A2C 222.91%);
      border-radius: 4px;
      font-family: Roboto;
      font-style: normal;
      font-weight: 500;
      font-size: 18px;
      line-height: 98.3%;
      color: #FFFFFF;
      padding: 12px 30px;
      text-decoration: none;
      @media (min-width: $width1) and (max-width: $width2) {
        font-size: 14px;
        padding: 10px 21px;
        line-height: 34.3%;

      }

      svg {
        margin-left: 32px;
        @media (min-width: $width1) and (max-width: $width2) {
          margin-left: 18px;
        }
      }
    }

    .gvtronics {
      @extend .gvmusic;
      padding: 10px 30px;
      background: unset;
      border: 10px solid;
      border-image-slice: 1;
      border-width: 1px;
      border-image-source: linear-gradient(to right, #DA0A2C, #f1eeef);
      margin-left: 20px;
      @media (min-width: $width1) and (max-width: $width2) {
        padding: 9px 21px;
        color: #DA0A2C;
      }


    }
  }
}
</style>
